import { useState } from "react";
import { Chip } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { statusChangeText, statusColor, statusLabel } from "./supportTicketStatus";

const when = (value) => (value ? new Date(value).toLocaleString() : "");

/** Folded by default: the current status is already on the ticket, the trail is for when it matters. */
const TicketStatusHistory = ({ history }) => {
  const [expanded, setExpanded] = useState(false);
  const changes = history || [];

  return (
    <section className="rounded-2xl border border-slate-200 bg-white">
      <button
        type="button"
        aria-expanded={expanded}
        aria-controls="ticket-status-history"
        onClick={() => setExpanded((value) => !value)}
        className="flex w-full items-center justify-between gap-2 rounded-2xl bg-transparent px-4 py-3 text-left sm:px-5"
      >
        <span className="text-sm font-semibold text-slate-900">
          Status history
          <span className="ml-2 font-normal text-slate-500">
            {changes.length} {changes.length === 1 ? "change" : "changes"}
          </span>
        </span>
        <ExpandMore
          fontSize="small"
          className={`text-slate-500 transition-transform ${expanded ? "rotate-180" : ""}`}
        />
      </button>
      {expanded ? (
        <ul
          id="ticket-status-history"
          className="m-0 list-none space-y-1 border-t border-slate-100 px-4 pb-4 pt-3 sm:px-5"
        >
          {changes.map((change) => (
            <li key={change.id} className="text-xs text-slate-600">
              <Chip
                size="small"
                color={statusColor(change.toStatus)}
                label={statusLabel(change.toStatus)}
                sx={{ mr: 1 }}
              />
              {statusChangeText(change)} · {when(change.createdAt)}
              {change.body ? <span className="italic"> ({change.body})</span> : null}
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
};

export default TicketStatusHistory;
